<template>
    <div class="full-page bg-primary">
        <div class="uk-card uk-card-body uk-card-default uk-position-center">
            <h1 class="uk-card-title">LOGIN</h1>
            <form>
                <div class="uk-margin">
                    <input class="uk-input" type="text" name="username" v-model="email" placeholder="email"/>
                </div>
                <div class="uk-margin">
                    <input class="uk-input" type="password" name="username" v-model="password" placeholder="password"/>
                </div>
                <div v-if="error" class="uk-alert-danger uk-margin">{{errorMessages[error.code] || error.code || error}}</div>
                <button class="uk-button uk-button-primary uk-align-right" :disabled="loading" type="submit" @click.prevent="login"><span v-if="!loading">AANMELDEN</span><div v-if="loading" uk-spinner></div></button>
                <div class="uk-margin">
                    <a class="uk-button uk-button-primary .uk-width-1-1" @click.prevent="loginFb()"><span uk-icon="icon: facebook"></span>Aanmelden met Facebook</a>
                </div>
            </form>
            <router-link to="wachtwoord-vergeten">Wachtwoord Vergeten?</router-link>
        </div>
    </div>
</template>
<script>
import {db, auth, rtdb} from '@/CUSTOM/helpers/firebase'
import * as firebase from 'firebase'
    export default {
        name: 'login',
        data () {
            return {
                email: '',
                password: '',
                error: null, 
                loading: false,
                errorMessages: {
                    'auth/invalid-email': 'Gelieve een correct emailadres in te vullen',
                    'auth/user-not-found': 'De combinatie van het email adres en wachtwoord klopt niet',
                    'auth/wrong-password': 'De combinatie van het email adres en wachtwoord klopt niet',
                }
            }
        },
        created() {
            this.$emit('loading', false)
        },
        methods: {
            login () {
                this.loading = true
                auth.signInWithEmailAndPassword(this.email, this.password).then(auth => {
                    this.$router.push('/')
                }).catch(error => {
                    this.loading = false
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.error = error
                });
            },
            loginFb () {
                var provider = new firebase.auth.FacebookAuthProvider();
                provider.setCustomParameters({
                    'display': 'popup'
                });
                this.loading = true
                auth.signInWithPopup(provider).then(r => {
                    return db.doc('users/' + r.user.uid).get()
                }).then(u => {
                    var user = u.data()
                    this.$router.push('/')
                    this.loading = false
                }).catch(error => {
                    if(auth.currentUser){
                        auth.currentUser.delete()
                    }
                    this.loading = false
                    this.error = 'Kon niet aanmelden met Facebook. Controleer of je reeds een account hebt en deze gekoppeld is aan je Facebook Account';
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Login.vue?781d09db